import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../BrandLogo/BrandLogo';
import './DesktopFooter.css';

// Chân trang giao diện PC, chỉ hiện từ 1024px (DesktopFooter.css); mobile dùng BottomNavigation - namespace: dfoot-*
const COLUMNS = [
  {
    title: 'Khám phá',
    links: [
      { to: '/', label: 'Trang chủ' },
      { to: '/flashsale', label: 'Flash Sale' },
      { to: '/ma-giam-gia', label: 'Mã giảm giá' },
      { to: '/ma-shop-0d', label: 'Mã shop 0đ' },
    ],
  },
  {
    title: 'Tài khoản',
    links: [
      { to: '/orders', label: 'Đơn hàng' },
      { to: '/payments', label: 'Rút tiền' },
      { to: '/lost-order-search', label: 'Tìm đơn thất lạc' },
      { to: '/account', label: 'Tài khoản' },
    ],
  },
  {
    title: 'Hỗ trợ',
    links: [
      { to: '/hoi-dap', label: 'Hỏi đáp' },
      { to: '/gioi-thieu', label: 'Giới thiệu CaskBack' },
      { href: 'https://zalo.me/0977668789', label: 'Zalo hỗ trợ' },
      { href: 'https://zalo.me/g/vqaaq1yn3pn4pox7yeoo', label: 'Nhóm săn sale' },
      { href: 'mailto:hieu.dv@caskback.vn', label: 'hieu.dv@caskback.vn' },
    ],
  },
];

const DesktopFooter = () => (
  <footer className="dfoot">
    <div className="dfoot__inner">
      <div className="dfoot__brand">
        <Link to="/" aria-label="CaskBack - Trang chủ">
          <BrandLogo className="dfoot__logo" />
        </Link>
        <p className="dfoot__tagline">Hoàn tiền khi mua sắm Shopee, Lazada, TikTok Shop. Dán link, mua hàng, nhận tiền về ví.</p>
      </div>
      {COLUMNS.map(({ title, links }) => (
        <nav key={title} className="dfoot__col" aria-label={title}>
          <h2 className="dfoot__title">{title}</h2>
          <ul>
            {links.map(({ to, href, label }) => (
              <li key={label}>
                {to ? (
                  <Link to={to}>{label}</Link>
                ) : (
                  <a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer">{label}</a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </div>
    <div className="dfoot__bottom">
      <span>© {new Date().getFullYear()} CaskBack. Bảo lưu mọi quyền.</span>
    </div>
  </footer>
);

export default DesktopFooter;
